var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 11.25V9.75H7.575C8.3625 9.75 9.04688 9.5 9.62813 9C10.2094 8.5 10.5 7.875 10.5 7.125C10.5 6.375 10.2094 5.75 9.62813 5.25C9.04688 4.75 8.3625 4.5 7.575 4.5H2.85L4.8 6.45L3.75 7.5L0 3.75L3.75 0L4.8 1.05L2.85 3H7.575C8.7875 3 9.82812 3.39375 10.6969 4.18125C11.5656 4.96875 12 5.95 12 7.125C12 8.3 11.5656 9.28125 10.6969 10.0688C9.82812 10.8563 8.7875 11.25 7.575 11.25H2.25Z",
    fill: "black",
    fillOpacity: 0.56
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUndo);
export default __webpack_public_path__ + "static/media/icon-undo.9d8be8fc2e58ef81b4113ff510a81741.svg";
export { ForwardRef as ReactComponent };